<template>
  <li
    class="__presentation"
  >
    <slot>
      <b-form-checkbox
        v-if="type === 'checkbox'"
        :key="filterName + '-' + value + '-' + selected"
        :checked="selected"
        @change="changeInputValue"
      >
        <div
          v-if="image !== ''"
          :id="`image-popover-${filterName}-${value}`"
          :key="`Image-${filterName}`"
          class="__dropdown--image"
          :style="{ backgroundImage: 'url(' + image + ')' }"
        />
        <b-popover
          v-if="image !== ''"
          class="filter-popover"
          :target="`image-popover-${filterName}-${value}`"
          triggers="hover"
          placement="top"
        >
          <div
            :id="`image-popover-${filterName}-${value}`"
            :key="`Image-${filterName}-${value}`"
            class="__dropdown--imagee-popover"
            :style="{ backgroundImage: 'url(' + image + ')' }"
          />
        </b-popover>
        <span
          v-if="checkTextWidth"
          v-b-tooltip.hover="label"
          class="__dropdown-submenu-label"
          :class="image !== '' ? 'ml-10px' : ''"
        >
          {{ label }}
        </span>
        <span
          v-else
          class="__dropdown-submenu-label"
          :class="image !== '' ? 'ml-10px' : ''"
        >
          {{ label }}
        </span>
      </b-form-checkbox>
      <b-form-radio
        v-else
        :key="filterName + '-' + value "
        :checked="selected"
        :name="filterName"
        :value="value"
        @change="changeInputValue"
      >
        <span
          v-if="checkTextWidth"
          v-b-tooltip.hover="label"
          class="__dropdown-submenu-label"
        >
          {{ label }}
        </span>
        <span
          v-else
        >
          {{ label }}
        </span>
      </b-form-radio>
    </slot>
  </li>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'checkbox',
    },
    label: {
      type: String,
      default: '',
    },
    selected: {
      type: [Boolean, String],
      default: false,
    },
    filterName: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    menuName: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },
  computed: {
    checkTextWidth() {
      return this.label.length >= 21
    },
  },
  methods: {
    changeInputValue() {
      this.$emit('change', this.filterName, this.value)
    },
  },
}
</script>

<style lang="scss">

.__presentation {
  display: flex;
  align-items: center;
  width: 100%;
  height: 34px;
  padding: 0px 4px 0px 12px;
  border-radius: 0.358rem;
  -webkit-border-radius: 0.358rem;
  -moz-border-radius: 0.358rem;
  -ms-border-radius: 0.358rem;
  -o-border-radius: 0.358rem;
  font-size: 14px;
  color: #667c99;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  &:hover {
    color: #1d79f2;
    background-color:#fafafa;
  }
  & > a.__dropdown-item{
      height: 34px;
      transition: all 0.25s;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
  }
  div.custom-checkbox {
    width: 100%;
    label.custom-control-label {
      padding: 0 !important;
        &::before{
          width: 16px !important;
          height: 16px !important;
          top: 3px;
        }
        &::after{
          width: 16px !important;
          height: 16px !important;
          top: 3px;
        }
    }
  }
  div.custom-radio {
    width: 100%;
    input.custom-control-input{
      &:not(:disabled){
        & ~ .custom-control-label{
          padding: 0 !important;
          &::after{
            width: 16px;
            height: 16px;
            top: 11px;
          }
          &::before{
          width: 16px;
          height: 16px;
          top: 11px;
        }
        }
      }
      &:checked{
        &:not(:disabled){
        & ~ .custom-control-label{
          padding: 0 !important;
          &::after{
            width: 16px;
            height: 16px;
            top: 11px;
          }
          &::before{
          width: 8px;
          height: 8px;
          top: 11px;
          left: 4px;
        }
        }
      }
      }
    }
  }
  input.__dropdown-input{
    height: 34px;
    font-size: 14px;
    padding: 0.15rem 0.4rem;
  }
}
span.__dropdown-submenu-label{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.__dropdown--image {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 0.558rem;
  height: 24px;
  width: 30px;
}
.__dropdown--imagee-popover {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 70px;
  width: 80px;
  border: none;
}

.filter-popover{
 .popover {
  .popover-body {
    padding: 4px;
    box-shadow: 6px 6px 26px 0px rgba(156, 156, 156, 0.75);
    border-radius: 0.358rem;
  }
  &.bs-popover-bottom {
    .arrow {
      &:after {
        border-bottom-color: #fff !important;
      }
      &:before {
        border-bottom-color: #fff !important;
      }
    }
  }
}
}

.ml-10px {
  margin-left: 10px;
}
</style>
